import React from 'react'
import LP_Header from './LP_header'
function LandingPageWrapper(props) {
  
  return (
    <div><LP_Header props={props}></LP_Header></div>
  )
}
export default LandingPageWrapper